<template>
  <v-select
    hide-details="auto"
    :items="status"
    v-model="filterDatas.purchaseOrderstatus"
    item-text="name"
    item-value="id"
    label="Status"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.purchaseOrderstatus)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      {
        id: 'Pending',
        name: 'Pending',
      },
      {
        id: 'Received',
        name: 'Received',
      },
      {
        id: 'Canceled',
        name: 'Cancelled',
      },
    ],
    selectStatus: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_PURCHASE_ORDER_STATUS_FILTER', data);

      this.$emit('input', this.filterDatas.purchaseOrderstatus);
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.purchaseOrderstatus);
  },
};
</script>
